import React, { Component } from 'react'
import AppLayout from "../AppLayout/AppLayout";
import BreadCrumbExtension, { IBreadCrumbExtension } from '../../Controls/BreadCrumbExtension/BreadCrumbExtension'
import {MSACCT_TITLE} from '../../Utilities/QueryBuilderConstants'

import ScanRequests from '../../ScanRequests/ScanRequests'

const breadcrumbItem: IBreadCrumbExtension[] = [
  { text: 'Home', key: 'Home', href: '/' },
  { text: 'Data Freshness', key: 'ia'},
  { text: 'Unified Data Platform', key: 'ia1'},
  { text: 'Evergreen', key: 'evergreen'},
];

export default class ScanRequestsUnifiedEvergreenPage extends Component {
  

  render() {
    document.title = MSACCT_TITLE + " | " + "Unified Data Platform (Evergreen)";
    return (
      <AppLayout
        renderBreadcrumb={() =>
          <BreadCrumbExtension items={breadcrumbItem} />
        }
        renderContentPane={() => <ScanRequests FactoryType='Database' FactoryName='Evergreen' />} />
    );
  }
}

